import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseBoolean, parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * An entry which represents a section within a visual inspection form.
 * Sections help organize fields into logical groups within a form.
 */
export class GeckoVisualInspectionSection extends GeckoEntryBase<
  {
    title: string
    description?: string
    order: number
    required: boolean
  },
  {
    organization: string
    site: string
    [RolodexEntryType.VISUAL_INSPECTION_FORM]: string
  },
  Record<string, never>
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        title: parseString(json.data.title) ?? '',
        description: parseString(json.data.description),
        order: parseNumber(json.data.order) ?? 0,
        required: parseBoolean(json.data.required) ?? false,
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        [RolodexEntryType.VISUAL_INSPECTION_FORM]:
          parseString(json.tags[RolodexEntryType.VISUAL_INSPECTION_FORM]) ?? '',
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a visual inspection section from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoVisualInspectionSection(json)
  }
}
